import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { SITE_ORIGIN } from "@/lib/site";

/**
 * SEO component: title, description, canonical, Open Graph, and JSON-LD.
 */
export const Seo = ({
  title,
  description,
  image,
  path,
  type = "website",
  jsonLd,
  noindex = false,
}) => {
  const location = useLocation();
  const canonical = `${SITE_ORIGIN}${path || location.pathname}`;
  const ogImage =
    image ||
    "https://images.unsplash.com/photo-1571753217087-980e556e16ea?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";
  const blocks = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet>
      <html lang="tr" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="tr_TR" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(b)}
        </script>
      ))}
    </Helmet>
  );
};

export default Seo;
